import styled from "styled-components";
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
} from "../../../constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const IconButtonAtomContainer = styled.div``;

export const IconWrapper = styled.button<{
  isSelected: boolean;
  biggerCursor?: boolean;
}>`
  position: relative;
  border: none;
  /* background-color: ${({ isSelected }) =>
    isSelected ? COLORS.RaisinBlack : "transparent"}; */
  background-color: ${COLORS.Yellow};
  border-radius: 100%;
  width: 42px;
  height: 42px;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  margin: 0 4px;
  padding: 5px;
  transition: 0.3s background-color ease-out;

  &:hover {
    background-color: ${COLORS.Yellow};
    transition: 0.3s ease-in;
  }

  &:focus {
    outline: none;
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    background-color: ${COLORS.Yellow};
  }
`;

export const IconWrapperDesktop = styled.button<{
  isSelected: boolean;
  biggerCursor?: boolean;
}>`
  position: relative;
  border: none;
  background-color: ${({ isSelected }) =>
    isSelected ? COLORS.RaisinBlack : "transparent"};
  border-radius: 100%;
  width: 42px;
  height: 42px;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  margin: 0 4px;
  padding: 5px;
  transition: 0.3s background-color ease-out;

  &:hover {
    background-color: ${COLORS.Yellow};
    transition: 0.3s ease-in;
  }

  &:focus {
    outline: none;
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    background-color: ${COLORS.Yellow};
  }
`;

export const IconImage = styled.img`
  width: auto;
  height: auto;
`;

export const HoverText = styled.div<{ isMobile?: boolean }>`
  visibility: ${({ isMobile }) => (isMobile ? "hidden" : "hidden")};
  background-color: ${COLORS.RaisinBlack};
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  color: ${COLORS.Cultured};
  padding: 8px;
  border-radius: ${BORDER_RADIUS.radius21};

  &::before {
    content: ${({ isMobile }) => (isMobile ? "none" : '""')};
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${COLORS.RaisinBlack};
  }

  ${IconWrapper}:hover & {
    visibility: ${({ isMobile }) => (isMobile ? "hidden" : "visible")};
  }
`;
